import FileSaver from 'file-saver';

import { post } from './rest';
import { getTenantId } from './firebase';

export const generateZebraLabels = (job, tasks, specification, count, embedType, blank) => {
  const tenantId = getTenantId();
  return post(`/v1/tenants/${tenantId}/jobs/${job.id}/labels`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      tasks,
      labelFormat: {
        type: 'zebra',
        specification,
      },
      labels: {
        count,
        embedType,
        blank,
      },
    }),
  });
};

export const generatePdfLabels = (job, tasks, labelFormat, sheets, embedType, blank) => {
  const tenantId = getTenantId();
  return post(`/v1/tenants/${tenantId}/jobs/${job.id}/labels`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'blob',
    body: JSON.stringify({
      tasks,
      labelFormat,
      labels: {
        sheets,
        embedType,
        blank,
      },
    }),
  }, false)
    .then((resp) => resp.blob())
    .then((resp) => {
      console.log('r3', resp);
      // const data = new Blob(resp.blob(), { type: 'application/pdf' });
      FileSaver.saveAs(resp, 'labels.pdf');
      return resp;
    });
};



// WEBPACK FOOTER //
// ./src/utils/labels.js